import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';
import { injectIntl } from 'react-intl';

const SaveChangesModal = ({ isOpen, onSave, onDontSave, onClose, intl }) => {
  if (!isOpen) return null;

  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: '24px',
      maxWidth: '400px',
      width: '100%',
      position: 'relative',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    closeButton: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      color: '#666',
    },
    title: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '12px',
      textAlign: 'center',
    },
    content: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '24px',
      textAlign: 'center',
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    saveButton: {
      backgroundColor: '#4500e2',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      padding: '10px 16px',
      fontSize: '14px',
      cursor: 'pointer',
      fontWeight: '500',
    },
    dontSaveButton: {
      backgroundColor: 'transparent',
      color: '#666',
      border: 'none',
      borderRadius: '4px',
      padding: '10px 16px',
      fontSize: '14px',
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  };

  return React.createElement(
    Modal,
    {
      isOpen,
      onRequestClose: onClose,
      style: {
        overlay: style.overlay,
        content: style.modal,
      },
    },
    [
      React.createElement(
        'button',
        {
          style: style.closeButton,
          onClick: onClose,
          type: 'button',
        },
        '×'
      ),
      React.createElement('div', { style: { paddingTop: '20px' } }, [
        React.createElement('h3', { style: style.title }, intl.formatMessage({ id: 'saveChangesBeforeLeaving' })),
        React.createElement('p', { style: style.content }, intl.formatMessage({ id: 'recentModificationsNotSaved' })),
        React.createElement('div', { style: style.actions }, [
          React.createElement(
            'button',
            {
              style: style.saveButton,
              type: 'button',
              onClick: onSave,
            },
            intl.formatMessage({ id: 'justSave' })
          ),
          React.createElement(
            'button',
            {
              style: style.dontSaveButton,
              type: 'button',
              onClick: onDontSave,
            },
            intl.formatMessage({ id: 'justDontSave' })
          ),
        ]),
      ]),
    ]
  );
};

SaveChangesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onDontSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(SaveChangesModal);
